class IntroService {
    private static introPopover: Ir.Components.General.Intro.IIntroPopover;
    private static introHints: boolean = false;

    static show(intro: Intro) {
        this.hideIntroHints();

        let validationMessage = intro.validation?.();

        if (validationMessage) {
            DevExpress.ui.notify(validationMessage);
            return;
        }

        if (!this.introPopover) {
            let introDiv = $(`<intro params="callback: callback"></intro>`);
            $("body").append(introDiv);
            ko.applyBindings({
                callback: function (component: Ir.Components.General.Intro.IIntroPopover) {
                    IntroService.introPopover = component;
                    IntroService.introPopover.show(intro);
                }
            }, introDiv[0]);
        }
        else {
            this.introPopover.show(intro);
        }
    }

    static showHints(hints: Array<IntroHint>) {
        if (!this.introHints) {
            if (hints.length === 0) {
                return;
            }

            let introHintsDiv = $(`<intro-hint params="hints: hints"></intro-hint>`);
            $("body").append(introHintsDiv);
            ko.applyBindings({
                hints
            }, introHintsDiv[0]);
            this.introHints = true;
        }
        else {
            Ir.Components.General.IntroHint.showHints(hints);
        }
    }

    private static _intros: Array<Intro>;
    static get intros() {
        if (!this._intros) {
            this._intros = [
                new Intro("EmptyWorkbook", "New Workbook - Create an Analysis Report",
                    [
                        new IntroStep(
                            "New Report",
                            `Here you can setup the report by clicking on the "Analyze by" button and choose one of the report templates.`,
                            ".intro-analyze-by",
                            ".intro-analyze-by-label",
                            null,
                            null,
                            (executeStep: Function) => {
                                $("toolbartab .dx-tab:has(.intro-report-tab)").trigger("click");
                                setTimeout(executeStep, 10);
                                return true;
                            }
                        ),
                        new IntroStep(
                            "Grouped Report",
                            `This dropdown allows you to select a report template to create a grouped report.`,
                            ".intro-group-by",
                            ".intro-group-by-label",
                        ),
                        new IntroStep(
                            "Change Report Type",
                            `Here you can change the report type (Report, Chart, Pivot).`,
                            ".intro-change-report-type",
                        ),
                        new IntroStep(
                            "Edit the Report",
                            `You can edit the report by clicking on the "Edit Report" button. This will open the report designer where you can modify the report fields, metrics, comparison filters, and other settings.`,
                            ".intro-edit-report",
                            null,
                            601,
                        ),
                    ],
                    true,
                    function (): string {
                        if (!workbook.workbookConfig.generalSettings.editing()) {
                            return "Turn on editing mode first.";
                        }
                        if (workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
                            if (workbook.workbookConfig.activeTab().dashboard.widgets().length == 0) {
                                return "First create a dashboard widget.";
                            }
                            workbook.workbookConfig.activeTab().dashboard.selectWidget(workbook.workbookConfig.activeTab().dashboard.widgets()[0]);
                            return workbook.workbookConfig.activeTabOrWidget()?.itemConfig() !== null ? "" : "First select a dashboard widget.";
                        }
                    }
                ),
                new Intro("WidgetSettings", "How to change the report settings",
                    [
                        new IntroStep(
                            "Settings Tab",
                            `Here you can see and edit the widget settings.`,
                            ".dx-tab:has(.intro-settings-tab)",
                            "tab-widget-settings",
                            null,
                            "right",
                            (executeStep: Function) => {
                                return workbook.workbookConfig.generalSettings.drawerWorkbookSideBars?.show().then(() => {
                                    $(".intro-settings-tab").trigger("click");
                                    setTimeout(executeStep, 10);
                                    return true;
                                });
                            }
                        ),
                        new IntroStep(
                            "Report Designer",
                            `This tab allows you to see and edit the report fields, groups, and metrics.`,
                            ".dx-tab:has(.intro-settings-tab-designer)",
                            null,
                            null,
                            "right",
                            () => {
                                $(".intro-settings-tab-designer").trigger("click");
                            }
                        ),
                        new IntroStep(
                            "Properties",
                            `Here you can see and edit the report properties.`,
                            ".dx-tab:has(.intro-settings-tab-properties)",
                            null,
                            null,
                            "right",
                            () => {
                                $(".intro-settings-tab-properties").trigger("click");
                            }
                        ),
                    ],
                    true,
                    function (): string {
                        if (!workbook.workbookConfig.generalSettings.editing()) {
                            return "Turn on editing to change the report settings.";
                        }
                        if (workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
                            if (workbook.workbookConfig.activeTab().dashboard.widgets().length == 0) {
                                return "First create a dashboard widget.";
                            }
                            workbook.workbookConfig.activeTab().dashboard.selectWidget(workbook.workbookConfig.activeTab().dashboard.widgets()[0]);
                            return workbook.workbookConfig.activeTabOrWidget()?.itemConfig() !== null ? "" : "First select a dashboard widget.";
                        }
                    },
                ),
                new Intro("Filters", "Filters - Workbook, Report, and Widget",
                    [
                        new IntroStep(
                            "Workbook Filters",
                            `Here you can see and edit the workbook filters that are applied to all workbook tabs.`,
                            "workbooksidetabs .intro-filters-workbook",
                            null,
                            null,
                            "right",
                            (executeStep: Function) => {
                                return workbook.workbookConfig.generalSettings.drawerWorkbookSideBars?.show().then(() => {
                                    $("workbooksidetabs .dx-tab:has(.intro-filters-tab)").trigger("click");
                                    setTimeout(executeStep, 10);
                                    return true;
                                });
                            },
                        ),
                        new IntroStep(
                            "Workbook Filters - Top",
                            `Filters are also available in the top toolbar. Here you can see and edit the workbook filters that are applied to all workbook tabs.`,
                            "toolbartab .intro-filters-workbook",
                            null,
                            null,
                            "bottom",
                            (executeStep: Function) => {
                                $("toolbartab .dx-tab:has(.intro-filters-tab)").trigger("click");
                                setTimeout(executeStep, 10);
                                return true;
                            },
                        ),
                        new IntroStep(
                            "Tab/Dashboard Filters",
                            `Here you can see and edit the filters that are applied only for the current workbook tab or dashboard. You can combine or overwrite the workbook filters with the tab filters to create a more specific report.`,
                            "workbooksidetabs .intro-filters-tab-dashboard",
                            null,
                            null,
                            "right",
                            null,
                        ),
                        new IntroStep(
                            "Tab/Dashboard Filters - Top",
                            `Filters are also available in the top toolbar. Here you can see and edit the filters that are applied only for the current workbook tab or dashboard. You can combine or overwrite the workbook filters with the tab filters to create a more specific report.`,
                            "toolbartab .intro-filters-tab-dashboard",
                            null,
                            null,
                            "right",
                            null,
                        ),
                        new IntroStep(
                            "Apply Filters",
                            `After modifying the filters, the Apply button will be enabled to apply all changes at once.`,
                            "workbooksidetabs .intro-filters-apply",
                            null,
                            null,
                            "right",
                            null,
                        ),
                        new IntroStep(
                            "Apply Filters - Top",
                            `Apply filters are also available in the top toolbar.`,
                            "toolbartab .intro-filters-apply",
                            null,
                            null,
                            "right",
                            null,
                        ),
                    ]
                ),
                new Intro("DashboardWidgets", "Add dashboard widgets",
                    [
                        new IntroStep(
                            "Widget types",
                            `Here you can find all widget types available to add to your dashboard.`,
                            "widgets-toolbar .intro-dashboard-widget-types:first",
                            "widgets-toolbar .intro-dashboard-widget-types:last",
                            null,
                            "bottom",
                            (executeStep: Function) => {
                                $("toolbartab .dx-tab:has(.intro-dashboard-tab)").trigger("click");
                                setTimeout(executeStep, 10);
                                return true;
                            },
                        ),
                        new IntroStep(
                            "Report Widget",
                            `Some widgets open a list of report templates that you can choose from.`,
                            ".intro-report-template-list-report .dx-overlay-content",
                            "widgets-toolbar .intro-dashboard-widget-types:first",
                            null,
                            "right",
                            (executeStep: Function) => {
                                $("widgets-toolbar .intro-dashboard-widget-types:first .intro-add-widget-button").trigger("click");
                                setTimeout(executeStep, 10);
                                return true;
                            },
                            (executeStep: Function) => {
                                console.log("Hiding popover");
                                $("widgets-toolbar .intro-dashboard-widget-types:first .createNewReportPopover").dxPopover("hide");
                                setTimeout(executeStep, 10);
                                return true;
                            }
                        ),
                        new IntroStep(
                            "Copy From",
                            `The Copy From button lets you create a new widget copying from other workbook tabs or dashboards.`,
                            ".intro-widget-copy-from",
                            null,
                            null,
                            "right",
                            null,
                        ),
                    ],
                    true,
                    function (): string {
                        if (!workbook.workbookConfig.generalSettings.editing()) {
                            return "Turn on editing to change the report settings.";
                        }
                        if (workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard) {
                            return "First switch to a dashboard tab.";
                        }
                    },
                ),
                new Intro("Intro", "Intro tour",
                    [
                        new IntroStep(
                            "Show Info Hints",
                            `You can click here to show info hints for the different parts of the application.`,
                            ".intro-hint-button",
                            null,
                            null,
                            "bottom",

                        ),
                        new IntroStep(
                            "Show Intro Tour List",
                            `You can click here to see a list of available intro tours.`,
                            ".intro-help-button",
                            null,
                            null,
                            "bottom",
                        ),
                    ]
                ),
            ];
        }
        return this._intros;
    }

    private static introListPopover: DevExpress.ui.dxPopover;

    static showIntroList() {
        let self = this;
        if (!this.introListPopover) {
            let div = $(`<div data-bind="dxPopover: popoverConfig"><div data-bind="dxList: listConfig"></div></div>`);
            let config = {
                popoverConfig: {
                    position: 'top',
                    width: 400,
                    showTitle: true,
                    title: "Available Help Tours",
                    showCloseButton: true,
                    wrapperAttr: {
                        class: "intro-list-popover",
                    },
                    onInitialized: function (e) {
                        self.introListPopover = e.component;
                        self.introListPopover.show(".intro-help-button");
                    },
                    onShowing(e) {
                    },
                    onHiding(e) {
                    },
                    toolbarItems: [
                        {
                            widget: 'dxButton',
                            toolbar: 'bottom',
                            location: 'after',
                            options: {
                                text: 'OK',
                                icon: 'check',
                                stylingMode: 'outlined',
                                type: 'normal',
                                elementAttr: {
                                    class: "intro-list-ok",
                                },
                                onClick() {
                                    self.introListPopover.hide();
                                },
                            },
                        },
                    ],
                },
                listConfig: {
                    dataSource: self.intros.filter(x => x.visibleOnList),
                    height: 200,
                    //searchEnabled: true,
                    displayExpr: 'name',
                    searchExpr: 'name',
                    onItemClick(e) {
                        self.introListPopover.hide();
                        (e.itemData as Intro).show(true);
                    },
                },
            };
            $("body").append(div);
            ko.applyBindings(config, div[0]);
        }
        else {
            self.introListPopover.show(".intro-help-button");
        }
    }

    static callIntroForEmptyWorkbook(showHints: boolean = true) {
        if (isMobile()) {
            return false; // No intro on mobile
        }
        let intro = this.intros.find(x => x.id === "EmptyWorkbook");
        return intro.show();
    }

    static callIntroForEmptyDashboard(showHints: boolean = true) {
        if (isMobile()) {
            return false; // No intro on mobile
        }
        let intro = this.intros.find(x => x.id === "DashboardWidgets");
        return intro.show();
    }

    static callIntroForIntro(showHints: boolean = true) {
        if (isMobile()) {
            return false; // No intro on mobile
        }
        let intro = this.intros.find(x => x.id === "Intro");
        return intro.show();
    }

    private static hints: Array<IntroHint> = [];

    static showIntroHintsForEmptyWorkbook(forceShow: boolean = false) {
        if (this.hints.length > 0 && forceShow) {
            this.hideIntroHints();
            return;
        }
        this.hints = [
            new IntroHint("ReportEdit", ".intro-edit-report", "Edit Report", `You can edit the report by clicking on the "Edit Report" button. This will open the report designer where you can modify the report fields, metrics, comparison filters, and other settings.`, null, 0, -5),
            new IntroHint("ReportChangeReportType", ".intro-change-report-type", "Change Report Type", `Here you can change the report type (Report, Chart, Pivot).`, null, 0, -5),
            new IntroHint("ReportAnalyzeBy", ".intro-analyze-by", "Analyze By", `This dropdown button is the current report being displayed. The User can change the Report displayed by clicking on the dropdown list in the Analyze by area. The new Report will display the same metrics as the original selected Report. Please note only Default reports can be selected.`, null, 0, -5),
            new IntroHint("ReportGroupBy", ".intro-group-by", "Group By/Pivot On", `You can edit the report by clicking on the "Edit Report" button. This will open the report designer where you can modify the report fields, metrics, comparison filters, and other settings.`, null, 0, -5),
            new IntroHint("ReportSwitch", ".intro-switch-analyze-by-group-by", "Switch Analyze By and Group By/Pivot On", `This button allows the User to switch the Analyzed Report with the Grouped/Pivot Report. For example, on a Category report grouped by Sales By Quarter, by clicking on the switch icon the report changes to display Sales By Quarter grouped by Category.`, null, 0, -5),
            new IntroHint("ReportTop", ".intro-report-top", "Top/Bottom", `The Top button allows the User to restrict the report results to display the Top X or Bottom X entries based off the chosen metric values. Default value of the Top tool is set to All. To change click on the All.`, null, 0, -5),

            new IntroHint("DrilldownSelect", ".intro-drilldown-select", "Next Drilldown Report", `This field displays the next report to be drilled into. This is a dropdown list of available Template Reports and allows the User to change the next report that they want to drill into. Higher level reports that have been drilled into can not be re-used and will be greyed out in the list as seen below.`, null, 0, -5),
            new IntroHint("DrilldownEdit", ".intro-drilldown-edit", "Changing the Drilldown list - Edit", `The Edit Button allows the User to change the drilldown list. This is useful if the User wants to change a number or Reports and not just the next level report. Clicking on the button results in the Edit drill-down list window appearing. This displays the list of the current Drill-down list.`, null, 0, -5),
            new IntroHint("DrilldownDrillup", ".intro-drilldown-drill-up", "Drill Up", `Use this button to return to the report immediately above the current report. The User can also drill up one or more report levels by clicking on the relevant report tab name under the Drilldown Icon bar.`, null, 0, -5),
            new IntroHint("DrilldownRollup", ".intro-drilldown-roll-up", "Roll-Up", `Use this button to return to the top level report. The User can also return to the top level by clicking on the report tab name under the Drilldown Icon bar.`, null, 0, -5),

            new IntroHint("Filters", "workbooksidetabs .intro-filters-tab", "Filters", `Here you can see and edit the filters for the different levels available in the workbook. Click on the Apply button after modifying the filters to apply all changes at once.`, "Filters", -14, 2),
            new IntroHint("Filters", "toolbartab .intro-filters-tab", "Filters", `Here you can see and edit the filters for the different levels available in the workbook. Click on the Apply button after modifying the filters to apply all changes at once.`, "Filters", 53, 2),
        ];
        if (forceShow) {
            for (let hint of this.hints) {
                hint.setVisible(true);
            }
        }
        this.showHints(this.hints);
    }

    static hideIntroHints() {
        // for (let hint of this.hints) {
        //     hint.visible(false);
        // }
        this.hints = [];
        this.showHints(this.hints);
    }

    static refreshIntroHints() {
        let self = this;
        setTimeout(() => {
            for (let hint of self.hints) {
                hint.refresh();
            }
        }, 100);
    }
}